// Contexto para anmazenar dados do ID do AutoComplete escolhido

import React, { createContext, useState } from "react";

export const TabelaPrecoIdContext = createContext()
export const TabelaPrecoNomeContext = createContext()

export const TabelaPrecoContextProvider = ({ children }) => {
    const [tabelaPrecoIdContext, setTabelaPrecoIdContext] = useState('')
    const [tabelaPrecoNomeContext, setTabelaPrecoNomeContext] = useState('')

    return (
        <TabelaPrecoIdContext.Provider value={{ tabelaPrecoIdContext, setTabelaPrecoIdContext }}>
            <TabelaPrecoNomeContext.Provider value={{ tabelaPrecoNomeContext, setTabelaPrecoNomeContext }}>
                {children}
            </TabelaPrecoNomeContext.Provider>
        </TabelaPrecoIdContext.Provider>
    )
}